import { render } from "./GraphicEditor.vue?vue&type=template&id=56202e94"
import script from "./GraphicEditor.vue?vue&type=script&lang=js"
export * from "./GraphicEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__